// 是否上架
export const appOnshelfStatus = async appId => {
  const url = `/${process.env.REACT_APP_API_CONTEXT}/service/isv/apps/onshelf/status/${appId}`;
  const res = await fetch(url, { method: "GET" });
  return res;
};

/**
 * @description 应用编辑
 * @param {string} appId
 * @param {Object} params
 * @param {string} params.batchId 头像
 * @param {string} params.descCn 描述
 * @param {string} params.descEn 描述
 * @param {string} params.keywords 关键词
 * @param {string} params.nameCn 应用名称
 * @param {string} params.nameEn 应用名称
 * @param {string} params.privacyLinkCn 中文隐私
 * @param {string} params.privacyLinkEn 英文隐私
 * @param {string} params.serviceFrom 应用介绍地址
 * @param {string} params.supportInfo 用户支持
 * @param {'innerapp'|'isv'} type innerapp-自建应用，isv-第三方应用
 * @returns
 */
export const editApp = (appId, params, type) => {
  const editAppUrl = {
    innerapp: "innerapp",
    isv: "isv/app"
  };
  const url = `/${process.env.REACT_APP_API_CONTEXT}/service/${editAppUrl[type]}/${appId}`;
  delete params.type;
  return fetch(url, { method: "PUT", body: params });
};

/**
 * @description 删除应用
 * @param {string} appId
 * @param {'innerapp'|'isv'} type innerapp-自建应用，isv-第三方应用
 * @returns
 */
export const deleteApp = (appId, type) => {
  const deleteAppUrl = {
    innerapp: "innerapp",
    isv: "isv/app"
  };
  const url = `/${process.env.REACT_APP_API_CONTEXT}/service/${deleteAppUrl[type]}/${appId}`;
  return fetch(url, { method: "DELETE" });
};

// 重置appSecret
export const resetSecret = async (params, type) => {
  const deleteAppUrl = {
    innerapp: "innerapp",
    isv: "isv/app"
  };
  let url = `/${process.env.REACT_APP_API_CONTEXT}/service/${deleteAppUrl[type]}/secret/${params.id}`;
  const res = await fetch(url, { method: "PUT", body: {} });
  return res;
};

// 获取企业管理员列表
export const getAdministrators = async appId => {
  const result = await fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/isvVersion/getAdministrators/${appId}`,
    { method: "GET" }
  );
  return result;
};

/**
 * @description 是否是协同开发者
 * @param {string} appId
 * @param {'innerapp'|'isv'} type innerapp-自建应用，isv-第三方应用
 * @returns
 */
export const getAppRole = async (appId, type) => {
  const fetchUrlPath = {
    innerapp: "innerapp",
    isv: "isv/app"
  };
  let url = `/${process.env.REACT_APP_API_CONTEXT}/service/${fetchUrlPath[type]}/role/${appId}`;
  const result = await fetch(url, { method: "GET" });
  return result;
};
